import React, {useState, useEffect} from "react";

const Section3 = ({products, select, setSelect, setStep}) =>{

    let sizes = products[select.material].properties.sizes
    let min_h = parseFloat(sizes.height.split('-')[0])
    let max_h = (isNaN(parseFloat(sizes.height.split('-')[1])) ? min_h : parseFloat(sizes.height.split('-')[1]))

    let [vars, setVars] = useState({
        height: select.height,
        length: select.length,
        indents: select.indents,
        Logo: select.logo,
        cut_flag: select.cut_flag,
        cutselect: select.cutStyle,
        min_h: min_h,
        max_h: max_h,
    })

    useEffect(() => {
        reItnit()
        if (vars.cutselect === undefined) document.querySelectorAll('.step-btns')[1].scrollIntoView({block: "end", behavior: "smooth"})
    })
    
    // adds 'ckecked' to cut-style radios if select present, draws product example
    /*useEffect(() => { 

        reItnit()
        
    },[vars, select.cut_flag]);*/

    function reItnit(){
        var elems = document.querySelectorAll('input[name=cut_option]');

        if (elems.length !== 0 && vars.cutselect === true){
            elems[0].checked = true;
        }else if (elems.length !== 0 && vars.cutselect === false){
            elems[1].checked = true;
        }

        elems = document.querySelector('#opt-cut_flag');
        if (elems !== null){
            elems.checked = select.cut_flag;
        }

        elems = document.querySelector('#calc_length').value
        if (vars.length === 0 ){
            vars.length = parseFloat(elems);
        }

        elems = document.querySelector('#calc_height').value
        if (vars.height === 0 ){
            vars.height = parseFloat(elems);
        }

        canvasRedraw()
    }

    function canvasRedraw(){

        /** example drawning
         * 
         * 1)
         *         L
         *    +-+-----+-+
         *   H| | LOGO| |
         *    | |     | |
         *    +-+-----+-+
         *     i
         * 2)
         *        
         *    A B(H)C   E D
         *    +-+---+---+-+
         *    | |   |   | |(L)
         *    +-+---+---+-+
         *    F^I   J   K P
         *    (S)
         * 3)
         *        !    i    L         ! 
         *   --+-----+---+-----+---+-----+--
         *     |     |   |     |   |     |  
         *     | logo|  H| logo|   | logo|  
         *     |     |   |     |   |     |  
         *   --+-----+---+-----+---+-----+--
         *        !                   !
         *  ! = cut position
         * 
         * 4)
         * 
         * 
         */

        if (vars.cutselect === undefined){
            return false;
        }
        let canvas = document.getElementById("canvas");
        canvas.style.maxWidth = window.getComputedStyle(canvas.parentElement).width;
        canvas.style.maxHeight = window.getComputedStyle(canvas.parentElement).height;
        let ctx = canvas.getContext('2d'),
            c_back = '#AAAA',    //colors
            c_front = '#aaa5',
            c_indent = '#0005',
            c_font = '#000',
            c_grd_1 = '#555a',
            c_grd_2 = '#aaa0',
            c_grd_3 = '#aaa0',
            c_grd_4 = '#fff7'
        //let img = new Image();
        //img.src = document.location.origin+'/wp-content/themes/experon-ebusiness-child/images/fabric.png';
        //img.src = 'http://birkislogo.web14.com.ua/wp-content/themes/experon-ebusiness-child/images/fabric.png';

        if (vars.cutselect && !select.cut_flag){
            /* 1) */
            let scale = 75;
            let I = vars.indents*scale,
                L = vars.length*scale,
                H = vars.height*scale
            ctx.canvas.width  = H + 2*I;
            ctx.canvas.height = L;
/*
            var pattern = ctx.createPattern(img, 'repeat'); //background image
            ctx.fillStyle = pattern;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
*/
            ctx.fillStyle = c_back
            ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height)

            ctx.fillStyle = c_indent // indents
            ctx.fillRect(0, 0, I, L)
            ctx.fillRect(I + H, 0, I , L)

            ctx.fillStyle = c_front //body
            ctx.fillRect(I, 0, H, L)

            var gradient = ctx.createLinearGradient(0, 0, 0, canvas.height) //decorative gradient
            gradient.addColorStop(0, c_grd_1)
            gradient.addColorStop(0.3, c_grd_2)
            gradient.addColorStop(0.7, c_grd_3)
            gradient.addColorStop(1, c_grd_4)
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, canvas.width, canvas.height)

            ctx.fillStyle = c_font; // text 
            ctx.font = `${0.8*L}px Quesha`;
            ctx.textBaseline = 'middle';
            ctx.textAlign = 'center';
            ctx.fillText(vars.Logo , canvas.width/2, canvas.height/2, 0.9*H);

        } else if (vars.cutselect && select.cut_flag) {
            /* 2) */
            let scale = 75,
                L = vars.length * scale ,    // height
                H = vars.height * scale /2,  // length
                S = vars.indents * scale     // indent

            ctx.canvas.width  = 2 * (H+S)
            ctx.canvas.height = L
/*
            pattern = ctx.createPattern(img, 'repeat');
            ctx.fillStyle = pattern;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
*/
            ctx.fillStyle = c_back
            ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height)

            ctx.fillStyle = c_indent // indents
            ctx.fillRect(0, 0, S, L)
            ctx.fillRect(S + 2*H, 0, S , L)

            ctx.fillStyle =  c_front //body
            ctx.fillRect(S, 0, H, L)
            ctx.fillRect(S + H, 0, H, L)

            ctx.beginPath() // break line
            ctx.moveTo( S + H , 0 )
            ctx.lineTo( S + H , L )
            ctx.stroke();

            gradient = ctx.createLinearGradient(0,0,0,L) // decorative gradient
            gradient.addColorStop(0, c_grd_1)
            gradient.addColorStop(0.3, c_grd_2)
            gradient.addColorStop(0.7, c_grd_3)
            gradient.addColorStop(1, c_grd_4)
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, canvas.width, canvas.height)

            ctx.rotate(90 * Math.PI / 180); // rotate CW

            ctx.fillStyle = c_font // print out text
            ctx.font = `${H*0.75}px Quesha`
            ctx.textBaseline = 'middle'
            ctx.textAlign = 'center'
            ctx.fillText(vars.Logo , L/2 , -H/2-S, L*0.8); 

            ctx.rotate(-180 * Math.PI / 180); // rotate CCW

            ctx.fillStyle = c_font // print out second text
            ctx.font = `${H*0.75}px Quesha`
            ctx.textBaseline = 'middle'
            ctx.textAlign = 'center'
            ctx.fillText(vars.Logo , -L/2 , 1.5*H + S, L*0.8);


        } else if (!vars.cutselect && !select.cut_flag) {
            /* 3) */
            let scale = 75,
                H = vars.length * scale,  // height
                L = vars.height * scale,  // length
                I = vars.indents * scale, // indent
                poly = [                  // contour poly sizes
                    0, 0,
                    L, 0,
                    L, H,
                    0, H,
                ]

            ctx.canvas.width  = L*2.4 + I * 2  //0.7L - I - 1L - I - 0.7L
            ctx.canvas.height = H
/*
            pattern = ctx.createPattern(img, 'repeat');
            ctx.fillStyle = pattern;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
*/
            ctx.fillStyle = c_back
            ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height)

            gradient = ctx.createLinearGradient(0, 0, 0, ctx.canvas.height)
            gradient.addColorStop(0, c_grd_1)
            gradient.addColorStop(0.2, c_grd_2)
            gradient.addColorStop(0.8, c_grd_3)
            gradient.addColorStop(1, c_grd_4)
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height)
                
            for (let i = 0; i < 3; i++){
                ctx.beginPath() // contour
                ctx.strokeStyle = c_font
                ctx.lineWidth = 1
                ctx.setLineDash([2,10]);
                ctx.moveTo(poly[0] + i*(L + I)-0.3*L, poly[1] )
                for(let item = 2 ; item < poly.length-1 ; item += 2 ){ctx.lineTo( poly[item] + i*(L + I)-0.3*L , poly[item + 1] )}
                ctx.closePath()
                //ctx.stroke()
                ctx.fillStyle = c_front
                ctx.fill()

                ctx.fillStyle = c_font
                ctx.font = `${H*0.80}px Quesha`
                ctx.textBaseline = 'middle'
                ctx.textAlign = "center"
                ctx.fillText(vars.Logo , ((poly[0] + i*(L + I)+0.2*L) + poly[1] + i*(L + I)+0.2*L)/2 , H/2, L*0.9)
            }

            gradient = ctx.createLinearGradient(0,0, 50,0) // left-side 'endless' border
            gradient.addColorStop(0, 'white')
            gradient.addColorStop(0.2, 'white')
            gradient.addColorStop(1, 'transparent')
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, 50, H);

            gradient = ctx.createLinearGradient(ctx.canvas.width-50,0, ctx.canvas.width,0) // right-side 'endless' border
            gradient.addColorStop(1, 'white')
            gradient.addColorStop(0.8, 'white')
            gradient.addColorStop(0, 'transparent')
            ctx.fillStyle = gradient
            ctx.fillRect(ctx.canvas.width-50, 0, ctx.canvas.width, H)

        } else if (!vars.cutselect && select.cut_flag){
            /* 4) */
            let scale = 75,
                L = vars.length * scale ,    // height
                H = vars.height * scale /2,  // length
                I = vars.indents * scale     // indent

            /*let textPos = [ H/2,
                            2*I + 3*H/2,
                            2*I + 5*H/2,
                            4*I + 7*H/2
                        ]*/

            let textPos = [-H/2 , 3*H/2 + 2*I , -5*H/2 - 2*I, 7*H/2 + 4*I]

            ctx.canvas.width  = 4*H + 4*I
            ctx.canvas.height = L

            ctx.fillStyle = c_back
            ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height)

            ctx.fillStyle = c_indent // indents
            ctx.fillRect(H, 0, I*2, L)
            ctx.fillRect(3*H+2*I, 0, 2*I, L)

            ctx.fillStyle = c_front //body
            ctx.fillRect(0, 0, H, L)
            ctx.fillRect(H+2*I, 0, 2*H, L)
            ctx.fillRect(3*H+4*I, 0, H, L)

            ctx.setLineDash([5, 3]) //dashed lines
            for (let i = 1; i < 4; i++){
                
                ctx.beginPath();
                ctx.moveTo((H + I)*i, 0);
                ctx.lineTo((H + I)*i, L);
                ctx.stroke();
            }


            ctx.rotate(90 * Math.PI / 180); // rotate CW
            ctx.fillStyle = c_font
            ctx.font = `${H*0.80}px Quesha`
            ctx.textBaseline = 'middle'
            ctx.textAlign = "center"
            for (let i = 0; i < 4; i++){ //text draw
                ctx.fillText(vars.Logo , L/2 , textPos[i] , L*0.9)
                ctx.rotate(-180 * Math.PI / 180)
                i++
                ctx.fillText(vars.Logo , -L/2 , textPos[i] , L*0.9)
                ctx.rotate(180 * Math.PI / 180)
            }

            ctx.rotate(-90 * Math.PI / 180);

            gradient = ctx.createLinearGradient(0,0, 50,0) // left-side 'endless' border
            gradient.addColorStop(0, 'white')
            gradient.addColorStop(0.2, 'white')
            gradient.addColorStop(1, 'transparent')
            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, 50, L);

            gradient = ctx.createLinearGradient(ctx.canvas.width-50,0, ctx.canvas.width,0) // right-side 'endless' border
            gradient.addColorStop(1, 'white')
            gradient.addColorStop(0.8, 'white')
            gradient.addColorStop(0, 'transparent')
            ctx.fillStyle = gradient
            ctx.fillRect(ctx.canvas.width-50, 0, ctx.canvas.width, L)

        }
    }

    function ShowFlag(){
        if (products[select.material].properties.submaterial[select.submaterial].cut_flag) {
            return (<label htmlFor="opt-cut_flag" onClick={() => setSelect({...select, cut_flag: !select.cut_flag})}> <input type="checkbox" name="opt-cut_flag" id="opt-cut_flag" /> {window.lang['s']['flagged']}?</label>)
        }
        else {
            return null;
        }
    }

    function FinishType() {
        if (select.cut && select.roll){
            return(
                <>  
                    <div className="cut-options">
                        <label htmlFor="opt_cut"  onClick={() => setVars({...vars, cutselect: true})}><input type="radio" name="cut_option" id="opt_cut" /> {window.lang['s3']['cut']}</label>
                        <label htmlFor="opt_roll" onClick={() => setVars({...vars, cutselect: false})}><input type="radio" name="cut_option" id="opt_roll" /> {window.lang['s3']['roll']} ({window.lang['s3']['by']} {select.roll_length} {window.lang['s']['units']['meters']})</label>
                    </div>
                    <ShowFlag />
                </>
            );
        }else if (select.cut && !select.roll){
            if (select.cutStyle === undefined) {
                setSelect({
                    ...select,
                    cutStyle: true
                })
            }
            vars.cutselect = true;
            return(
                <>
                    <span>{window.lang['s3']['cut_only']}</span>
                    <ShowFlag />
                </>
            );
        }else if (!select.cut && select.roll){
            if (select.cutStyle === undefined) {
                setSelect({
                    ...select,
                    cutStyle: false
                })
            }
            vars.cutselect = false;
            return(
                <>
                    <span>{window.lang['s3']['roll_only']} ({window.lang['s3']['by']} {select.roll_length} {window.lang['s']['units']['meters']})</span>
                    <ShowFlag />
                </>
            );
        } else {
            return(
                <h3>{window.lang['s3']['err_no_options']}</h3>
            );
        }
    }

    function Indent(){
        switch (vars.cutselect){
            case false:
                return(
                    <legend>{window.lang['s3']['padding']}</legend>
                );
            case true:
                return(
                    <legend>{window.lang['s3']['indent']}</legend>
                );
            default:
                return(
                    <legend>{window.lang['s3']['select_indent']}</legend>
                );
        }
    }

    function OptionLength(){

        let optionsList;
        let disabled = false;

        switch (vars.cutselect) {
            case true:
                optionsList = sizes.length_grouping
                .filter((item) => {
                    if (Array.isArray(item.count_n_price) || item.count_n_price.length === 0){
                        return true
                    } else {
                        return false
                    }})

                if (optionsList.length === 1 && vars.length === -1){
                    vars.length = parseFloat(optionsList[0].length)
                    optionsList = (<option value={optionsList[0].length} selected>{optionsList[0].length} {window.lang['s']['units']['cm']}</option>)
                    disabled = true
                    break;
                }

                if (vars.length === -1){
                    vars.length = parseFloat(optionsList[0].length)
                }

                optionsList = optionsList.map((item, i) =>{
                    if (vars.length === parseFloat(item.length)){
                        return(<option key={i} value={item.length} selected>{item.length} {window.lang['s']['units']['cm']}</option>)
                    }else{
                        return(<option key={i} value={item.length}>{item.length} {window.lang['s']['units']['cm']}</option>)
                    }
                })

                break;

            case false:
                optionsList = sizes.length_grouping
                .filter((item) => {
                    if (Array.isArray(item.roll_n_price) || item.roll_n_price.length === 0){
                        return true
                    } else {
                        return false
                    }})

                if (optionsList.length === 1 && vars.length === -1){
                    vars.length = parseFloat(optionsList[0].length)
                    optionsList = (<option value={optionsList[0].length} selected>{optionsList[0].length} {window.lang['s']['units']['cm']}</option>)
                    disabled = true
                    break;
                }

                if (vars.length === -1){
                    vars.length = parseFloat(optionsList[0].length)
                }

                optionsList = optionsList.map((item, i) =>{
                    if (vars.length === parseFloat(item.length)){
                        return(<option key={i} value={item.length} selected>{item.length} {window.lang['s']['units']['cm']}</option>)
                    }else{
                        return(<option key={i} value={item.length}>{item.length} {window.lang['s']['units']['cm']}</option>)
                    }
                })
                break;

            case undefined:
                optionsList = (<option value={-1} disabled selected>{window.lang['s3']['select_indent']}</option>)
                break;
                
            default:
                optionsList = (<option value={-1} disabled selected>! {window.lang['s3']['select_indent']} !</option>)
                break;
        }

        if (!disabled){
            return (
                <select id="calc_length" onChange={() =>updateLength()}>
                    {optionsList}
                </select>
            )
        }else{
            return(
                <select id="calc_length" onChange={() =>updateLength()} disabled>
                    {optionsList}
                </select>
            )
        }
    }

    function InputHeight(){
        let str = {}
        if (min_h !== max_h){
            str = (
                <>
                    <legend>{window.lang['s']['units']['length']} ({min_h}{window.lang['s']['units']['cm']} - {max_h}{window.lang['s']['units']['cm']})</legend>
                    <input 
                        type="number" 
                        id="calc_height" 
                        min={min_h} 
                        max={max_h} 
                        step="0.1" 
                        onChange={() => updateHeight()} value={vars.height === 0 ? min_h : vars.height} 
                        onFocus={() => document.querySelector('#calc_height').select()}
                        onBlur={() => fixHeight()}
                    />
                </>
            )
        }else{
            str = (
                <>
                    <legend>{window.lang['s']['units']['length']}</legend>
                    <input type="text" id="calc_height" value={`${min_h}`} disabled />
                </>
            )
            vars.height = min_h
        }
        return str
    }

    function updateLength(){
        setVars({...vars,
            length: parseFloat(document.querySelector("#calc_length").value)
        });
    }

    function updateHeight(){
        let item = document.querySelector("#calc_height")
        let height = parseFloat(item.value);
        if (isNaN(height)){
            setVars({...vars, height: 0});
        }else{
            if ((height < min_h || height > max_h) && !item.classList.contains('input-warn') ){
                item.classList.add('input-warn')
            } else if (height > min_h && height < max_h && item.classList.contains('input-warn') ){
                item.classList.remove('input-warn')
            }
            setVars({...vars, height: height})
        }
    }
    
    function fixHeight(){
        let item = document.querySelector("#calc_height")
        let height = parseFloat(item.value);
        if (isNaN(height)){
            setVars({...vars, height: 0});
        }else  {
            if (height < min_h) height = min_h
            if (height > max_h) height = max_h
            setVars({...vars, height: height})
        }
        if (item.classList.contains('input-warn') ){
        item.classList.remove('input-warn')
        }
    }

    function updateIndents(){
        let item = document.querySelector("#calc_indents")
        let indents = parseFloat(item.value);
        if (isNaN(indents)){
            setVars({...vars, indents: 0});
        }else  {
            if ((indents < 0 || indents > 1) && !item.classList.contains('input-warn') ){
                item.classList.add('input-warn')
            } else if (indents > 0 && indents < 1 && item.classList.contains('input-warn') ){
                item.classList.remove('input-warn')
            }
            setVars({...vars, indents: indents});
        }
    }

    function fixIndents(){
        let item = document.querySelector("#calc_indents")
        let indents = parseFloat(item.value);
        if (isNaN(indents)){
            setVars({...vars, indents: 0});
        }else  {
            if (indents < 0) indents = 0
            if (indents > 1) indents = 1
            setVars({...vars, indents: indents});
        }
        if (item.classList.contains('input-warn') ){
        item.classList.remove('input-warn')
        }
    }

    function onButtonClick(){
        if (select.cut && select.roll && document.querySelectorAll('input[name="cut_option"]:checked').length === 0 ){
            alert(window.lang['s3']['select_cut_style']);
            return;
        }
        updateHeight();
        updateLength();
        updateIndents();
        setSelect({
            ...select,
            length: vars.length,
            height: vars.height,
            indents: vars.indents,
            logo: document.querySelector("#calc_logo_text").value,
            cutStyle: vars.cutselect,
            cut_flag: vars.cut_flag
        })
        setStep(4);
    }

    function goBack(){
        setSelect({ // '-1' === undefined
            material: -1, 
            submaterial: -1, 
            cut: false,
            cut_flag: false,
            roll: false,
            cutStyle: undefined,
            roll_length: -1,
            length: 0,
            height: 0, 
            indents: 0.5,
            logo: 'BirkisLogo',
            amount: 0,
            basicPrice: {
                priceForAmout: 0
            },
            options: {
                by_amount: 1,
                by_length: 1,
                by_width: 1,
                by_color_count: 1
            },
            finalPrice: {},
            colors:{
                main:'',
                other:''
            },
            calculatedPrice: -1,
            optionsNames:[],
            created: 0
        })
        setStep(1)
    }

    return(
        <>
            <div className="section_header">
                <h1>{window.lang['s3']['title']}</h1>
                <div className="step-btns">
                    <button className="btn btn-prev" onClick={() => goBack()} ><span>{window.lang['s3']['btn_prev']}</span></button>
                    <button className="btn btn-next" onClick={() => onButtonClick()} ><span>{window.lang['s3']['btn_next']}</span></button>
                </div>
            </div>
            <div className={`calc_preview ${vars.cutselect === undefined ? "d-none" : ''}`}>
                <canvas id="canvas"></canvas>
            </div>
            <div className={`calc_size_container ${vars.cutselect === undefined ? "d-none" : ''}`}>

                <div className="size-item">
                    <legend>{window.lang['s']['units']['height']}</legend>
                    <OptionLength />
                </div>

                <div className="size-item">
                    {InputHeight()}
                </div>
                
                <div className="size-item">
                    <Indent />
                    <input 
                        type="number" 
                        id="calc_indents" 
                        min="0" 
                        max="1" 
                        step="0.1" 
                        value={vars.indents} 
                        key="input_indent"
                        onChange={() => updateIndents()}
                        onFocus={() => document.querySelector('#calc_indents').select()}
                        onBlur={() => fixIndents()}
                    />
                </div>

                <div className="size-item">
                    <legend>{window.lang['s3']['text']}</legend>
                    <input type="text" id="calc_logo_text" onChange={() => setVars({...vars, Logo: document.querySelector("#calc_logo_text").value})} defaultValue={vars.Logo} />
                </div>

            </div>

            <div className={`calc_cut_container ${vars.cutselect === undefined ? "select-warn" : 'select-ok'}`}>
                <h3>{window.lang['s3']['finish']}</h3>
                <FinishType />
            </div>
            <div className="step-btns">
                    <button className="btn btn-prev" onClick={() => goBack()} ><span>{window.lang['s3']['btn_prev']}</span></button>
                    <button className="btn btn-next" onClick={() => onButtonClick()} ><span>{window.lang['s3']['btn_next']}</span></button>
            </div>
        </>
    )
}

export default Section3;